import {
  REGISTER_START,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  CHECK_EMAIL_START,
  CHECK_EMAIL_SUCCESS,
  CHECK_EMAIL_FAILURE,
  TERMS_LOADING,
  TERMS_LOADED,
  TERMS_ERROR
} from './actions';

const initialState = {
  registering: false,
  success: false,
  registered: false,
  registerError: null,
  checkingEmail: false,
  emailChecked: false,
  emailValid: null,
  loading: true,
  terms: null
};

export default (state = {}, action) => {
  const newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case REGISTER_START:
      newState.registering = true;
      newState.success = false;
      newState.registered = false;
      newState.registerError = false;
      break;
    case REGISTER_SUCCESS:
      newState.registering = false;
      newState.success = true;
      newState.registered = true;
      newState.registerError = false;
      break;
    case REGISTER_FAILURE:
      newState.registering = false;
      newState.success = false;
      newState.registered = false;
      newState.registerError = action.payload;
      break;
    case CHECK_EMAIL_START:
      newState.checkingEmail = true;
      break;
    case CHECK_EMAIL_SUCCESS:
      newState.checkingEmail = false;
      newState.emailChecked = true;
      newState.emailValid = action.payload;
      break;
    case CHECK_EMAIL_FAILURE:
      newState.checkingEmail = false;
      newState.emailChecked = true;
      newState.emailValid = action.payload;
      break;
    case TERMS_LOADING:
      newState.loading = true;
      newState.terms = null;
      break;
    case TERMS_LOADED:
      newState.loading = false;
      newState.terms = action.payload;
      break;
    case TERMS_ERROR:
      newState.loading = false;
      newState.terms = null;
      break;
    default:
      // oh well!
      break;
  }
  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/register/reducer.js